import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './style.scss'

export default class TextCell extends Component {
    static propTypes = {
        text: PropTypes.string,
    }

    render() {
        const { text } = this.props

        return <div className={'import-group-result-text-cell'}>{text || '-'}</div>
    }
}
